import React, { Component } from 'react';
////import { updateDirectUploadState } from "../../actions/appActions"
////import { setDirectUploadUrl } from "../../actions/appActions"
import Dropzone from './Dropzone'
import Cropper from 'react-cropper'
import 'cropperjs/dist/cropper.css'
////import { cropImage } from "../../actions/appActions"
import axios from "axios"

let previousTask;

export default class DirectUploader extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {loadedImage: false} // image upload status
    }

    componentDidMount() {

    }

    fakedImageSelect = (e, imageSRc) => {
        e.preventDefault();
       // store.dispatch(updateDirectUploadState(false, this.props.directUploadEditorId, imageSRc)); // actual call, use this with real data
    };

    cancelImageUpload = (e) => {
        e.preventDefault();
        //store.dispatch(updateDirectUploadState(false, null, null));
    };

    setloadedImage = (loadedImage) => {
        this.setState({loadedImage: loadedImage})
    }

    componentWillMount() {
    }

    _crop() {
        //console.log("Cropper clicked")
        //const dataUrl = this.refs.cropper.getCroppedCanvas().toDataURL()
        //console.log(dataUrl)
    }


    submbitCropToServer(cropData) {

        let cropDataString = JSON.stringify(cropData)
        cropDataString = 'json=' + encodeURIComponent(cropDataString) // Weird formatting required for Hywell's cropper script
        
        let cropperURL = 'https://services.coreprint.net/cropper/process-image.php'
        //let cropperURL = 'https://vpress.free.beeceptor.com'

        axios({
            method: 'post',
            url: cropperURL,
            headers: {},
            data: cropDataString
        }).then( res => {
            // console.log("Formed URL: ", res.data)
            let slicedResponse = res.data.substr(9) // Remove the word "response("
            slicedResponse = slicedResponse.substr(0, slicedResponse.length-2) // Remove trailing ")"
            // console.log("Sliced URL: ", slicedResponse)
            let parsedResponse = JSON.parse(slicedResponse)
            // console.log("Parsed URL: ", parsedResponse)
            let s3Key = parsedResponse.s3Key
            // console.log("s3Key: ", s3Key)
            let bucketName = "coreprintdamlive"
            let region = "s3-eu-west-1"
            let customerFolder = "NIC003"
            let croppedResourceURL = `https://${bucketName}.${region}.amazonaws.com/${customerFolder}/${s3Key}`
            console.log("Full URL: ", croppedResourceURL)


            this.props.setUplodaedImage(croppedResourceURL);
        })

    }


    _handleSaveCrop(e) {
        // On button press, submit URL
        e.preventDefault(); 

        var uploadfolder = "NIC003" // MOVE THIS TO PROPS LATER

        // This will need refactoring - currently only uses Live
        var s3Bucket = "coreprintdamlive";
        if (document.location.href.toLowerCase().indexOf("test-aspire") != -1 ) {
            s3Bucket = "coreprintdamtest";
        } else if (document.location.href.toLowerCase().indexOf("fester") != -1 ) {
            s3Bucket = "coreprintdamgolf";
        } else if (document.location.href.toLowerCase().indexOf("http://192.168.1.71") != -1 ) {
            s3Bucket = "coreprintdamgolf";
        }

        let cropData = this.refs.cropper.getData(true)
    
        let cropJSON = {
          "s3Bucket": s3Bucket,
          "folder": uploadfolder,
          "imageUrl": this.state.loadedImage,
          "originalName": "testFileName",
          "cropData": cropData
        }

        console.log(cropJSON);

        this.submbitCropToServer(cropJSON);

        //console.log('directUploadEditorField', this.props.directUploadEditorField)
        // console.log("this.props.directUploadEditorField.imageheight: ", this.props.directUploadEditorField.imageheight)
        ////store.dispatch(cropImage(cropJSON, this.props.selectedFolder, this.props.directUploadEditorField))

    }





    render() {
        return <div class="coreprint-modal" id="coreprint-modal-dam" style={{"display":"flex"}}>
        <div class="coreprint-modal-content">
                
                <div id="coreprint-dam-file-uploader" style={{"background-color":"#FFFFFF","width":"100%;"}}>

                        {/* Uploads file to S3 */}
                        
                        {(()=>{

                            let setRatio = this.props.uploadingField.imagewidth / this.props.uploadingField.imageheight

                            if (this.state.loadedImage) {
                                {/* Show the cropper to user */}
                                return <Cropper
                                    ref='cropper'
                                    src={this.state.loadedImage} // url of the image to be cropped
                                    style={{height: 400, width: '100%'}}
                                    guides={true}
                                    zoomable={false}
                                    rotatable={true}
                                    background={false}
                                    zoomOnTouch={false}
                                    viewMode={2}
                                    zoomOnWheel={false}
                                    restore={false}
                                    responsive={true}
                                    movable={false}
                                    checkOrientation={false}
                                    aspectRatio={setRatio} // calculated from 
                                    crop={this._crop.bind(this)}
                                    //cropmove={this._cropmove.bind(this)}
                                    autoCropArea={1}
                                />
                            } else {
                                return <Dropzone setloadedImage={this.setloadedImage} />
                            }
                        })()}


                        </div>


                        <div style={{"background-color":"#FFFFFF","padding-top":"10px","text-align":"right","width":"100%;"}}>


                        {/* After crop set this.props.directUploadUrl */}


                          {(()=>{

                            if(this.state.loadedImage){
                                return <button onClick={(e) => this._handleSaveCrop(e)} className="button alt">Submit</button>
                            
                            }

                        })()}


                         {/*<button onClick={(e) => this.fakedImageSelect(e, "https://via.placeholder.com/2000")} className="button">Fake it</button>*/}
                         <button style={{"marginLeft":"5px"}} onClick={(e) => this.props.hideDirectUploaderModal(e)} className="button">Cancel</button>

                        </div>


        </div>
    </div>
    }
}


